export const enum ThemePaletteMode {
    Dark = 'dark',
    Light = 'light'
};
